/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * The an end place to put fragments after they have been fetched.
 * @interface Logger
 * @ignore
 */

/**
* This method allows you to send fatal error messages (fatal errors implies playback interruption) to the browser's console.
* @param {...*} arguments The message you want to debug. The Arguments object is supported for this method so you can send in comma separated logging items.
* @function Logger#fatal
*/

/**
 * This method allows you to send error messages to the browser's console.
 * @param {...*} arguments The message you want to debug. The Arguments object is supported for this method so you can send in comma separated logging items.
 * @function Logger#error
 */

/**
 * This method allows you to send warning messages to the browser's console.
 * @param {...*} arguments The message you want to debug. The Arguments object is supported for this method so you can send in comma separated logging items.
 * @function Logger#warning
 */

/**
 * This method allows you to send info messages to the browser's console.
 * @param {...*} arguments The message you want to debug. The Arguments object is supported for this method so you can send in comma separated logging items.
 * @function Logger#info
 */

/**
 * This method allows you to send debug messages to the browser's console.
 * @param {...*} arguments The message you want to debug. The Arguments object is supported for this method so you can send in comma separated logging items.
 * @function Logger#debug
 */
